import { render, staticRenderFns } from "./bind_particulars1.vue?vue&type=template&id=1553b12b&scoped=true&"
import script from "./bind_particulars1.vue?vue&type=script&lang=js&"
export * from "./bind_particulars1.vue?vue&type=script&lang=js&"
import style0 from "./bind_particulars1.vue?vue&type=style&index=0&id=1553b12b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1553b12b",
  null
  
)

export default component.exports